// Open-source licences (public page, /licences): THIRD-PARTY-NOTICES.md as the app ships it (public/third-party-notices.md), shown with a
// small Markdown reader (headings, paragraphs, lists, tables, `code`) - plain React elements, no HTML from the file is ever injected.
import { useEffect, useState } from 'react'
import { NOTICES_FILE, PRIVACY_URL, TERMS_URL, OSM_TEXT } from '../lib/legal'
import { parseNotices } from '../lib/notices'

// `code` and **bold** inside a line
function inline(text, key) {
  return String(text).split(/(`[^`]+`|\*\*[^*]+\*\*)/g).filter(Boolean).map((p, i) =>
    p.startsWith('`') ? <code key={key + i} style={s.code}>{p.slice(1, -1)}</code>
    : p.startsWith('**') ? <b key={key + i}>{p.slice(2, -2)}</b> : p)
}
export default function Licences() {
  const [md, setMd] = useState(null)
  const [err, setErr] = useState('')
  useEffect(() => {
    fetch(NOTICES_FILE).then(r => { if (!r.ok) throw new Error(r.status); return r.text() }).then(setMd).catch(() => setErr('The licence list could not be loaded. Reload the page.'))
  }, [])
  return (
    <div style={s.page}>
      <div style={s.wrap}>
        <div style={s.top}><a href="/" style={s.back}>← Hey Captain</a></div>
        {err && <div className="err-box">{err}</div>}
        {!md && !err && <div style={{ color: 'var(--muted)' }}>Loading…</div>}
        {md && parseNotices(md).map((b, i) =>
          b.h ? (b.level === 1 ? <h1 key={i} style={s.h1}>{b.text === 'Third-party notices' ? 'Open-source licences' : b.text}</h1> : <h2 key={i} style={s.h2}>{inline(b.text, i)}</h2>)
          : b.ul ? <ul key={i} style={s.ul}>{b.items.map((t, j) => <li key={j}>{inline(t, i + '-' + j)}</li>)}</ul>
          : b.table ? (
            <div key={i} style={s.tableWrap}><table style={s.table}><thead><tr>{b.head.map((c, j) => <th key={j} style={s.th}>{c}</th>)}</tr></thead>
              <tbody>{b.rows.map((r, j) => <tr key={j}>{r.map((c, k) => <td key={k} style={s.td}>{inline(c, i + '-' + j + '-' + k)}</td>)}</tr>)}</tbody></table></div>)
          : <p key={i} style={s.p}>{inline(b.text, i)}</p>)}
        <div style={s.foot}>{OSM_TEXT} · <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={s.a}>Privacy</a> · <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={s.a}>Terms</a> · Hey Captain, operated by Ladislav Nabelek (sole trader) · hello@heycaptain.io</div>
      </div>
    </div>
  )
}

const s = {
  page: { minHeight: '100vh', background: 'var(--ink, #f3f5f9)', color: 'var(--text, #0a1628)', padding: '24px 16px' },
  wrap: { maxWidth: 860, margin: '0 auto', fontSize: 14, lineHeight: 1.5 },
  top: { marginBottom: 12 },
  back: { color: 'var(--muted)', textDecoration: 'none', fontSize: 13 },
  h1: { fontSize: 24, margin: '4px 0 10px' },
  h2: { fontSize: 16, margin: '22px 0 8px' },
  p: { margin: '8px 0', color: 'var(--muted)' },
  ul: { margin: '6px 0', paddingLeft: 20, color: 'var(--muted)' },
  code: { fontSize: 12.5, background: 'var(--hull, #eef1f5)', padding: '1px 4px', borderRadius: 4 },
  tableWrap: { overflowX: 'auto', border: '0.5px solid var(--border)', borderRadius: 10 },
  table: { borderCollapse: 'collapse', width: '100%', fontSize: 13 },
  th: { textAlign: 'left', padding: '7px 10px', background: 'var(--hull, #eef1f5)', borderBottom: '0.5px solid var(--border)' },
  td: { padding: '6px 10px', borderBottom: '0.5px solid var(--border)', verticalAlign: 'top' },
  foot: { marginTop: 24, fontSize: 12, color: 'var(--muted)' },
  a: { color: 'var(--muted)' },
}
